<template>
  <div></div>
</template>

<script>
import data from "../../data/data.json";

export default {
  name: "Arrow",
  props: {},
  data() {
    return {
      data: data,
    };
  },
};
</script>

<style lang="scss"></style>
